module.exports = "<things-details></things-details>\r\n<things-edit></things-edit>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/pages/things/details.component.html
// module id = ../../../../../src/app/pages/things/details.component.html
// module chunks = main